export const CATEGORY_ID_ZELL = '02b9c5b0-4733-44f7-8ddb-afaf53b05d7d';
export const CATEGORY_ID_MAMBACH = 'f2ceab4c-389c-4278-8c8a-7c946911a493';
